import React from "react";

const FilterRadioButtons = ({
  options,
  handleChange = () => {},
  value,
  label,
  disabled,
  name = "",
  valueclass = "flex gap-2 flex-col ml-1",
  className = "flex flex-col justify-between ml-1",
  inputClass = "",
  subClass = "flex items-center",
}) => {
  return (
    <div className={className}>
      <label className=" text-[var(--items-search-input-color)] text-[length:var(--items-search-input-font-size)] font-[var(---items-search-place-font-weight)] pb-2 ">
        {label}
      </label>
      <div className={valueclass}>
        {options?.map((option) => (
          <div key={option?.value} className={subClass}>
            <input
              type="radio"
              disabled={disabled}
              className={inputClass}
              id={option.value + name}
              name={name}
              value={option.value}
              checked={value === option?.value}
              onChange={handleChange}
            />
            <label
              htmlFor={option.value + name}
              className="ml-2 text-[var(--items-search-input-color)] text-[17px] font-[var(---items-search-place-font-weight)] cursor-pointer whitespace-nowrap"
            >
              {option.label}
            </label>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FilterRadioButtons;
